/** Every /admin/* list route shares this envelope. `total` already counts
 *  the whole filtered list (not just the page), so one call is enough to
 *  draw a pager no separate count request needed. */
export class AdminPagination {
  page!: number;
  perPage!: number;
  total!: number;
  pages!: number;

  constructor(data: any = {}) {
    this.page = data.page;
    this.perPage = data.per_page;
    this.total = data.total;
    this.pages = data.pages;
  }
}

export interface AdminPage<T> {
  rows: T[];
  pagination: AdminPagination;
}

/** A list page whose endpoint also returns `totals` for the whole filtered
 *  list. `totals` is null while the backend doesn't send it yet. */
export interface AdminTotalsPage<T, Totals> extends AdminPage<T> {
  totals: Totals | null;
}
